<mat-form-field>
	<mat-label>{{ 'leftmenu.company-search' | translate }}</mat-label>
	<input #input autocompleteOff matInput type="text" [(ngModel)]="query" (ngModelChange)="queryChanged()" placeholder="{{ 'leftmenu.company-search' | translate }}" />
	<mat-icon matSuffix fontSet="fa" [fontIcon]="this.pendingSearch ? 'fa-spinner-third' : 'fa-search'" />
</mat-form-field>
<div><custom-input inputType="switch" [label]="'company-search.include-inactive-companies' | translate" [(value)]="includeInactiveCompanies" /></div>

<div class="search-results" scrollable (scroll)="scrolledResults()" #searchResultContainer>
	@for (result of visibleResults; track result.companyId) {
		<div class="search-result field-small" prefixIcon="bullet-prefix" [ngClass]="{ active: result == highlightedResult, 'inactive-company': !result.hasActivePlans }" (click)="selectCompany(result)">
			<div class="match"><highlighter [text]="result.companyName" [highlight]="query" /></div>
			@if (displayVatNumber) {
				<div class="details">{{ 'company-search.details.vat-number' | translate: { vatNumber: result.vatNumber } }}</div>
			}
			<div class="result-matches">
				@for (value of result.matchValues; track value) {
					@if (matchValue(value.value, value.type)) {
						<div><highlighter [text]="value.type == 'phone' ? (value.value | phoneNumber) : value.value" [highlight]="query" /></div>
					}
				}
			</div>
		</div>
	}
	@if (!this.pendingSearch && query.length >= 2 && visibleResults.length == 0) {
		<div class="no-results">
			<div>{{ 'company-search.no-results' | translate }}</div>
			<div><img src="/assets/images/no-results.svg" /></div>
		</div>
	}
</div>
